var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m23.765 29.577-17.29-12.13-2.132 1.49a3.416 3.416 0 0 0 0 5.598l3.867 2.712 4.488-3.132 1.644 1.16-6.128 4.286-4.952-3.476a5.314 5.314 0 0 1 0-8.7l1.565-1.093-1.565-1.097a5.313 5.313 0 0 1 0-8.7L8.23 3l17.292 12.13 2.123-1.482a3.416 3.416 0 0 0 0-5.597l-3.867-2.712-4.48 3.136-1.644-1.159 6.132-4.29L28.742 6.5l-.004-.01a5.314 5.314 0 0 1 0 8.7l-1.57 1.096 1.566 1.098a5.314 5.314 0 0 1 0 8.7l-4.969 3.493zm1.743-12.13 2.133 1.494a3.416 3.416 0 0 1 0 5.599l-3.87 2.707-15.633-10.96 6.209-4.336-1.644-1.158-6.214 4.34-2.133-1.496a3.416 3.416 0 0 1 0-5.598L8.227 5.33 23.86 16.291l-6.218 4.345 1.644 1.159 6.222-4.348z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoom);
export default __webpack_public_path__ + "static/media/LOOM.92b7cf0f3aa9c968a79efe14c460a409.svg";
export { ForwardRef as ReactComponent };